import React, { Component } from 'react'
import {
  MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,MDBAlert,
  MDBCarouselInner,
  MDBCarouselItem
} from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBTypography  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message, Spin  } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import logo from './img/logokpru.png'
import image from './img/ppk.jpeg'
import Swal from 'sweetalert2'
import Modalregisterauthorities from './register/Modalregisterauthorities';
import Modallogin from './register/Modallogin';
//import ParticlesBg from 'particles-bg'
import cg5 from './img/cg3.png'
import cg3 from './img/cg3.jpg'
import cg from './img/cg.jpg'
import banner from './img/banner.jpg'
import banner2 from './img/banner2.png'

export default class Homepage3 extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      student:'',
      Loading: false,

      code: '',

      stdid:'',
      bddate:'',
      name:'',
      vut:'',
      number_true:'',

      check_have: false,

      checkrub : false,
      checknorub : false,
      checkrubpic : false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.getstudent = this.getstudent.bind(this);
    this.linkto = this.linkto.bind(this);
    this.checkrub = this.checkrub.bind(this);
    this.checknorub = this.checknorub.bind(this);
    this.getstudentcheck = this.getstudentcheck.bind(this);
    this.checkrubpic = this.checkrubpic.bind(this);

  }



  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }

  onTextChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  linkto() {
  //  window.location.href = 'https://e-student.kpru.ac.th/webregisfinish/'  ;   
    window.location.href = 'https://e-student.kpru.ac.th/webregisfinish/creck_codepassfor/'+this.state.stdid+'/'+this.state.bddate  ;   


  }

  checkrub() {
    this.setState({ checkrub:true })  
  }

  checkrubpic() {
    this.setState({ checkrubpic:true })  
  }

  checknorub() {
    Axios.get('https://mua.kpru.ac.th/frontend_tabian/student/UpdateStudentGradceremony/'+this.state.code,
    {headers: {
  
     }}
    )
    .then(res => {

        if (res.data === 1) {
            this.setState({ checknorub:true })  
        }

    }) 

    
  


  }

  componentDidMount() {
    this.setState({ check_have_qn: '' })
    localStorage.clear();

    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    
  }


//ตรวจสอบมีสิทธิ์รับปริญญาและตรวจสอบกรอกข้อมูลภาวะการมีงานทำ
  getstudent() {
  //  console.log("llllll");

  this.setState({ Loading:true })

  setTimeout(() => {
  
                //ตรวจสอบมีสิทธิ์รับปริญญา
                     Axios.get('https://mua.kpru.ac.th/frontend_tabian/student/ShowStudentGradceremony/'+this.state.code,
                                {headers: {
                                }}
                                )
                                .then(res => {
                                //  console.log("ddss");
                                //  console.log(res.data);
                                  if (res.data.length != 0 ) {

                                  const  stdid = res.data[0].stdid ;
                                  const  name = res.data[0].name +" "+ res.data[0].lname;
                                  const  vut = res.data[0].vut ;
                                  const  number_true = res.data[0].number_true ;
                                  const  bdate = res.data[0].bdate;
                                
                                
                                        
                                         // ตรวจสอบกรอกข้อมูลภาวะการมีงานทำ
                                          Axios.post('https://e-student.kpru.ac.th/webgeduate2563/api/getdata/get_history_status_finish', ({ STD_ID: stdid }))
                                                .then((res) => {
                                                    //console.log(res.data[0])
                                                    let data_check = res.data[0]
                                                    if (res.data.length >= 1) {

                                                        this.setState({ check_have_qn: true })
                                                        if (data_check.QN_WORK_STATUS === null || data_check.QN_WORK_STATUS === undefined || data_check.QN_WORK_STATUS === "") {
                                                            this.setState({ check_have_qn_all: false, load: false })
                                                            console.log('NO1')

                                                            Swal.fire({
                                                              title: 'ท่านยังกรอกข้อมูลภาวะการมีงานทำไม่ครบ',
                                                              text: "ท่านยังกรอกข้อมูลภาวะการมีงานทำไม่ครบ กดตกลงเพื่อเข้าสู่หน้าเพิ่มข้อมูล",
                                                              icon: 'warning',
                                                              // showCancelButton: true,
                                                              confirmButtonText: 'ตกลง',
                                                              showConfirmButton: true,
                                                              // cancelButtonText: 'No, keep it'
                                                              }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                              this.setState({Loading :false ,
                                                                              code: '',
                                                                              name:'',
                                                                              })   
                                                                 //รอลิงค์ 
                                                                window.location.href = 'https://employment.kpru.ac.th/Login_pagefromcheck/'+stdid+'/'+bdate  ;  
                                                                }
                                                                this.setState({Loading :false })
      
                                                              })

                                                        }
                                                        else {
                                                            this.setState({ check_have_qn_all: true, load: false })
                                                            console.log('YES')  

                                                                    this.setState({ 
                                                                      stdid: stdid ,
                                                                      name: name,
                                                                      vut: vut,
                                                                      number_true: number_true,
                                                                      bddate:bdate,
                                                                      Loading: false 
                                                                    })
                                                                   
                                                                    

                                                        }
                                                    }
                                                    else {
                                                        this.setState({ check_have_qn: false, load: false })
                                                        console.log('NO2')

                                                        Swal.fire({
                                                          title: 'ท่านยังไม่ได้กรอกข้อมูลภาวะการมีงานทำ',
                                                          text: "ท่านยังไม่ได้กรอกข้อมูลภาวะการมีงานทำ กดตกลงเพื่อเข้าสู่หน้าเพิ่มข้อมูล",
                                                          icon: 'warning',
                                                          // showCancelButton: true,
                                                          confirmButtonText: 'ตกลง',
                                                          // cancelButtonText: 'No, keep it'
                                                          }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                          this.setState({Loading :false ,
                                                                                      code: '',
                                                                                      name:'',
                                                                        })   
                                                                        //รอลิงค์
                                                                        window.location.href = 'https://employment.kpru.ac.th/Login_pagefromcheck/'+stdid+'/'+bdate  ;  
                                                            }
                                                           
                                                              this.setState({Loading :false ,
                                                              code: '',
                                                              name:'',
                                                               })   
                                                           
                                                          })
                                                    }
                                                })


                                  }else{
                                    this.setState({Loading :false })

                                            Swal.fire({
                                          title: 'ไม่พบข้อมูล',
                                          text: "ท่านยังไม่มีรายชื่อเข้ารับพระราชทานปริญญาบัตรในปีนี้",
                                          icon: 'warning',
                                          // showCancelButton: true,
                                          confirmButtonText: 'ตกลง',
                                          // cancelButtonText: 'No, keep it'
                                          }).then((result) => {
                                            this.setState({Loading :false ,
                                                          code: '',
                                                          name:'',
                                            })   //  this.toggle();

                                          })

                                  }
                                }) 

           }, 5000);


  }//ปิด



  getstudentcheck() {
  
    this.setState({ Loading:true })
  
    setTimeout(() => {
    
                  //ตรวจสอบมีสิทธิ์รับปริญญา
                       Axios.get('https://mua.kpru.ac.th/frontend_tabian/student/ShowStudentGradceremony/'+this.state.code,
                                  {headers: {
                                  }}
                                  )
                                  .then(res => {
                                  //  console.log("ddss");
                                  //  console.log(res.data);
                                    if (res.data.length != 0 ) {
  
                                    const  stdid = res.data[0].stdid ;
                                    const  name = res.data[0].name +" "+ res.data[0].lname;
                                    const  vut = res.data[0].vut ;
                                    const  number_true = res.data[0].number_true ;
                                    const  bdate = res.data[0].bdate;

                                    this.setState({ 
                                        stdid: stdid ,
                                        name: name,
                                        vut: vut,
                                        number_true: number_true,
                                        bddate:bdate,
                                        Loading: false 
                                      })
  
  
                                    }else{
                                      this.setState({Loading :false })
  
                                              Swal.fire({
                                            title: 'ไม่พบข้อมูล',
                                            text: "ท่านยังไม่มีรายชื่อเข้ารับพระราชทานปริญญาบัตรในปีนี้",
                                            icon: 'warning',
                                            // showCancelButton: true,
                                            confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.setState({Loading :false ,
                                                            code: '',
                                                            name:'',
                                              })   //  this.toggle();
  
                                            })
  
                                    }
                                  }) 
  
             }, 5000);
  
  
    }//ปิด







  render() {
   // console.log(this.state.name)
    return (
      // <div style={{ backgroundImage:`url(${image})` }}>
      <MDBContainer  >

        <img src={logo} className="rounded mx-auto d-block w-5 " alt="aligment" /><br />

        <h2 className="text-center" style={{fontSize:'clamp(12px,4vw,32px)'}}> ตรวจสอบรายชื่อ/ลงทะเบียนเข้ารับพระราชทานปริญญาบัตร</h2>
         <p className="text-center"> ผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร ประจำปีการศึกษา 2564-2565</p>
          <p className="text-center"> มหาวิทยาลัยราชภัฏกำแพงเพชร </p>
        {/* <p className="text-center"> ประจำปีการศึกษา 2564-2565</p> */}
       
        <MDBRow >
            
        {/* <MDBCol md="3" className="d-flex justify-content-center">

        </MDBCol> */}

        <MDBCol md="6" className="d-flex justify-content-center">
        <MDBCard style={{ width: "32rem", marginTop: "1rem" }}>
        <MDBCardBody>
          <MDBView  className='text-center'>

              <img
                src={banner2}
                className="img-fluid"
                alt=""
              />

              <MDBMask className="flex-center">
                <p className="white-text"></p>
              </MDBMask>
          </MDBView>
        </MDBCardBody>
        </MDBCard>
        </MDBCol>

          <MDBCol md="6" className="d-flex justify-content-center">
            <MDBCard style={{ width: "32rem", marginTop: "1rem" }}>
              <MDBCardBody>
                <MDBCardTitle className="text-center"></MDBCardTitle>
                <div className="text-center">
                <MDBIcon fas icon="user-graduate"  size="4x" className="text-center" />
                </div> 
                <br />

                <div className="mb-2">
                  <label>รหัสนักศึกษา/เลขบัตรประจำตัวประชาชน</label>
                  <input className="form-control" onChange={this.onTextChange} name="code"
                    value={this.state.code} placeholder="กรุณาระบุ รหัสนักศึกษา/เลขประจำตัวประชาชน" maxlength="13" required />
                </div>
                           

                <div className="text-center">
                  {this.state.Loading === true ?<>
                   <div className="example">
                    <Spin size="large" tip="Loading..." />
                  </div>
                   </> :<>
                   {this.state.code === '' ?<>
                   <MDBBtn color="deep-orange"  disabled  >ตรวจสอบ</MDBBtn>
                   </>:<>

                   {/* <MDBBtn color="deep-orange" onClick={this.getstudentcheck} >ตรวจสอบ</MDBBtn> */}
                   <MDBBtn color="deep-orange" onClick={this.getstudent} >ตรวจสอบ</MDBBtn>
                   </>}
                    </>}
                </div>

                <br/>
  
               
               {this.state.name === '' ?<></>:<>
                   {/* <MDBAlert color="primary" > */}
                   <MDBCard className="gradient transbox"   >
                   <h5 className="font-weight-bold text-center teal-text"><MDBIcon icon="check" /> มีสิทธิ์เข้ารับปริญญาบัตร</h5><br/>

                   {/* <p className="font-weight-bold text-center teal-text">ลำดับเข้ารับปริญญาบัตร </p> 
                   <MDBTypography tag="h1" variant="display-1" className="font-weight-bold text-center teal-text" style={{fontSize:'clamp(12px,100vw,70px)'}}>{this.state.number_true}</MDBTypography> */}

                   <h1 className="font-weight-bold text-center teal-text">{this.state.number_true}</h1>

                          {/* <p className="font-weight-bold">ลำดับเข้ารับปริญญาบัตร : {this.state.number_true}</p> */}
                          <p className="font-weight-bold">รหัสนักศึกษา : {this.state.stdid}</p>
                          <p className="font-weight-bold">ชื่อ-นามสกุล : {this.state.name}</p>
                          <p className="font-weight-bold">วุฒิที่สำเร็จการศึกษา :  {this.state.vut}</p>

                          {/* <p className="font-weight-bold red-text text-center"> *ขณะนี้ระบบปิดรับลงทะเบียนแล้ว</p> */}

                         {/* เปิดปิด */}
                         
                          {/* {this.state.checkrub === false && this.state.checknorub === false && this.state.checkrubpic === false ?<>
                           <div className='text-center'>
                               <MDBBtn color="primary" onClick={this.checkrub}>ประสงค์เข้ารับ</MDBBtn>
                               <MDBBtn color="unique" onClick={this.checknorub}>ไม่ประสงค์เข้ารับ</MDBBtn>
                               <MDBBtn color="deep-orange" onClick={this.checkrubpic}>ไม่ประสงค์เข้ารับ แต่ประสงค์ถ่ายภาพ </MDBBtn>
                            </div>
                          </>:<></>} */}
                            <MDBCard color="teal" text="white" tag="a"  onClick={this.linkto} >
                                <MDBCardBody><h2 className='text-center text-white'>ลงทะเบียนเข้ารับ <MDBIcon fas icon="mouse-pointer" /></h2></MDBCardBody>
                            </MDBCard>
                            {/* เปิดปิด */}

                          {/* {this.state.checkrub === true ?<>
                            <MDBCard color="indigo" text="white" tag="a"  onClick={this.linkto} >
                                <MDBCardBody><h1 className='text-center text-white'>ลงทะเบียนเข้ารับ</h1></MDBCardBody>
                            </MDBCard>
                          </> :<>
                          </>}
                          {this.state.checkrubpic === true ?<>
                            <MDBCard color="deep-orange" text="white" tag="a"  onClick={this.linkto} >
                                <MDBCardBody><h1 className='text-center text-white'>ลงทะเบียนถ่ายภาพ</h1></MDBCardBody>
                            </MDBCard>
                          </> :<>
                          
                          </>} */}


                          {this.state.checknorub === true ?<>
                            <MDBCard color="pink lighten-2" text="white" tag="a"  >
                                {/* <MDBCardBody><h5 className='text-center text-white'>ท่านสามารถขอรับใบปริญญาบัตรได้ที่ สำนักส่งเสริมวิชาการและงานทะเบียน มหาวิทยาลัยราชภัฏกำแพงเพชร </h5>
                                <h5 className='text-center text-white'>ตั้งแต่วันที่ 20 ธันวาคม 2566 เป็นต้นไป</h5>
                                
                                </MDBCardBody> */}
                            </MDBCard>
                          </> :<>
                          
                          </>}

                         
                    {/* </MDBAlert> */}
                    </MDBCard>
              
                   
                   </>}   

                
               
                   <a href="https://std.kpru.ac.th/kpnnews/prnews/file/graduate-kpru-2567.pdf" target="_blank" class="text-decoration-none"> <p className="font-weight-bold text-body"><MDBIcon icon="bullhorn" /> ประกาศเรื่อง การรายงานตัวของบัณฑิตที่จะเข้ารับพระราชทานปริญญาบัตร ประจำปี 2567</p></a>
                   <hr/>
                  
                   <a href="https://std.kpru.ac.th/th/hotnews/graduate-kpru-2567.php" target="_blank" class="text-decoration-none"> <p className="font-weight-bold text-body"><MDBIcon icon="bullhorn" /> ศูนย์รวมข้อมูลข่าวสารการรับพระราชทานปริญญาบัตร ปี 2567 </p></a>
                   <hr/>
                    
                 
                   <p className="font-weight-bold red-text"> *หมายเหตุ บัณฑิตที่ลงทะเบียนและชำระเงินแล้ว มหาวิทยาลัยขอสงวนสิทธิ์การเรียกเงินคืนทุกกรณี</p>
 {/* <p className="font-weight-bold red-text text-center mb-2 mt-2" style={{fontSize:'clamp(6px,4vw,12px)'}}> *หมายเหตุ กำหนดการลงทะเบียนบัณฑิต จะแจ้งให้ทราบภายหลัง</p> */}
                   <p className="text-center "> สอบถามเพิ่มเติม กองพัฒนานักศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร </p>
                   {/* <p className="text-center "> สอบถามเพิ่มเติม กองพัฒนานักศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร โทร 055706555 ต่อ 1302</p> */}
              {/* <p className="font-weight-bold red-text text-center"> *หมายเหตุ กำหนดการลงทะเบียนบัณฑิต จะแจ้งให้ทราบภายหลัง</p> */}
              </MDBCardBody>
            </MDBCard>
          </MDBCol>


    




        </MDBRow>

      </MDBContainer>
      //  </div>


    )
  }
}
